import React from "react";
import { motion } from "framer-motion";
import { FaRegSmile } from "react-icons/fa";
import { BsPersonVcard } from "react-icons/bs";
import { PiScrollLight } from "react-icons/pi";
import BenefitsCar from "../../assets/images/03-1.jpg";

const BenefitColumn = ({ icon: Icon, title, description, index }) => (
  <motion.div 
    className="flex flex-col items-center text-center shadow-2xl p-20 border-r last:border-r-0 border-r-gray-200"
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{
      duration: 0.5,
      delay: index * 0.2
    }}
    whileHover={{ 
      scale: 1.02,
      transition: { duration: 0.2 }
    }}
  >
    <motion.div 
      className="mb-6 text-5xl text-gray-300"
      whileHover={{ 
        scale: 1.1,
        color: "#ef4444",
        transition: { duration: 0.2 }
      }}
    >
      <Icon />
    </motion.div>
    <h3 className="text-xl font-semibold mb-4 Aleo">{title}</h3>
    <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
  </motion.div>
);

const Benefits = () => {
  const benefits = [
    {
      icon: FaRegSmile,
      title: "Our Customers Always 100% Satisfied",
      description:
        "Something happened on the road during your Mykonos adventure? Contact us anytime, and our dedicated team will come to your place, ensuring you receive the necessary assistance along the way",
    },
    {
      icon: BsPersonVcard,
      title: "We Provide Easier & Faster Bookings",
      description:
        "Experience unparalleled convenience as you effortlessly book your rental car in Mykonos, achieving a seamless process with just 3 simple clicks with no booking charges needed.",
    },
    {
      icon: PiScrollLight,
      title: "Car Insurance",
      description:
        "In our Mykonos Car Rentals Services you quarantee travel safety – we handle all risks on our own. All of our cars have valid insurance policies​",
    },
  ];

  return (
    <section id="benefits" className="py-16 mx-auto overflow-visible">
      <div className="flex flex-col lg:flex-row gap-12 relative">
        {/* Left Section */}
        <motion.div 
          className="lg:w-1/4 pl-8"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="max-w-[350px]">
            <motion.h2 
              className="text-6xl mb-4 Aleo"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Our Benefits
            </motion.h2>
            <motion.p 
              className="text-gray-600 text-md mb-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              Experience the <b>Luxury Mykonos Car Rentals</b> at Affordable
              Prices
            </motion.p>
            <motion.hr 
              className="w-24 border-2 border-red-500 mb-4"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            />
          </div>
        </motion.div>

        {/* Right Section */}
        <div className="lg:w-3/4 relative px-8">
{/* Background Image
          <div
            className="absolute right-0 -top-36 translate-y-1/2 w-1/2"
            style={{
              backgroundImage: `url(${BenefitsCar})`,
              backgroundPosition: "top right",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              height: "800px",
              zIndex: 0,
            }}
          /> */}
          {/* Content */}
          <div className="border-2 shadow-2xl bg-white rounded-md border-gray-300 relative z-10 ">
            <div className="grid grid-cols-1 md:grid-cols-3">
              {benefits.map((benefit, index) => (
                <BenefitColumn key={index} {...benefit} index={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
